import { render } from "./IconKebab.vue?vue&type=template&id=e83f9b6c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconKebab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e83f9b6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e83f9b6c', __exports__)) {
    api.reload('e83f9b6c', __exports__)
  }
  
  module.hot.accept("./IconKebab.vue?vue&type=template&id=e83f9b6c", () => {
    api.rerender('e83f9b6c', render)
  })

}


export default __exports__